export default {
    props: {
        entries: {
            type: Object,
            default: () => {
                return {};
            },
        },
        openOnLoad: {
            type: Boolean,
            default: true,
            description: 'If set to true, then the active key will be set to the first key in entries on component mount.'
        },
        allowToggleClose: {
            type: Boolean,
            default: true,
            description: 'If set to true, then calling activeKey on the current activeKey will set the active key to blank and close all open elements.'
        },
        selectedKey: {
            type: String,
            // validator(key) {
            //     return [null, undefined, '', ...Object.keys(this.entries)].includes(key);
            // },
            default: null,
        },
    },
    mounted() {
        if (this.openOnLoad) {
            const availableKeys = Object.keys(this.entries);
            if (availableKeys.length > 0) {
                this.internalActiveKey = availableKeys[0];
                if(this.selectedKey === '') {
                    this.$emit('change', availableKeys[0]);
                }
            }
        }
    },
    data() {
        return {
            internalActiveKey: null,
        };
    },
    computed: {
        activeKey() {
            return [null, undefined].includes(this.selectedKey)
                ? this.internalActiveKey
                : this.selectedKey;
        }
    },
    methods: {
        setActiveKey(key) {
            if (this.allowToggleClose && this.activeKey === key) {
                this.internalActiveKey = '';
                this.$emit('change', '');
            } else {
                this.internalActiveKey = key;
                this.$emit('change', key);
            }
        },
    }
};
